import AllWorkshop from './AllWorkshop.gql';

export default AllWorkshop;
